var map = {
	"./cnn-money-x2.png": 1941,
	"./cnn-money.png": 2151,
	"./economist-x2.png": 1942,
	"./economist.png": 2152,
	"./mashable-x2.png": 1943,
	"./mashable.png": 2153,
	"./tech-crunch-x2.png": 1944,
	"./tech-crunch.png": 2154,
	"./thenewyorker-x2.png": 1945,
	"./thenewyorker.png": 2155,
	"./thrillist-x2.png": 1946,
	"./thrillist.png": 2156,
	"./time-x2.png": 1947,
	"./time.png": 2157,
	"./usa-today-x2.png": 1948,
	"./usa-today.png": 2158
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2150;